<template>
<v-app v-bind:style="stylePagina">

    <v-container class="container--fluid pa-0" >
      <v-parallax

height="700"
          src="https://tunayeventos.s3.us-east-2.amazonaws.com/kd/fotoportada3.jpg"
      >
        <v-app-bar
            app
            absolute
            color="transparent"
            :elevation="0"
        >
          <v-toolbar-title>
            <router-link :to="{ name: 'karenydaniel'}">
              <v-img
                  alt="Tunay Logo"
                  class="shrink mt-1  hidden-sm-only hidden-xs-only"
                  contain
                  min-width="100"
                  src="https://tunayeventos.s3.us-east-2.amazonaws.com/kd/lognukd.png"
                  width="100"
              /></router-link>

            <router-link :to="{ name: 'karenydaniel'}">
              <v-img
                  alt="Tunay Logo"
                  class="shrink mt-1  hidden-md-only hidden-lg-only hidden-xl-only"
                  contain
                  min-width="50"
                  src="https://tunayeventos.s3.us-east-2.amazonaws.com/kd/lognukd.png"
                  width="50"
              /></router-link>
          </v-toolbar-title>
        </v-app-bar>
        <section class="mb-8 mb-lg-4 mb-md-4 fill-height" >

          <v-row
              align="center"
              justify="center"
              class="mt-12"
          >
            <v-col
                class="text-center mt-12"
                cols="12"
            >
              <center><h1 class="text-h2 mt-12 pt-12" style="font-family: 'Playfair Display'!important; font-style: italic; ">Karen & Daniel</h1></center>
              <center><h2 class="text-h5 mt-2 mb-12 pb-12" style="font-family: 'Playfair Display'!important; font-style: italic;">Nos casamos</h2></center>
            </v-col>
          </v-row>
          <v-row justify="center" align="center" class="mt-12">
            <v-col class="text-center mt-6 pt-6 mt-lg-12 pt-lg-12 mt-md-12 pt-md-12" cols="12">
              <countdown :time="tiempo">
                <template slot-scope="props">
                  <v-row justify="center" align="center">
                    <v-col cols="3" lg="1" md="1">
                      <v-row>
                        <v-col cols="12" class="text-h3 font-weight-bold mb-0 pb-0">
                          {{ props.days }}
                        </v-col>
                        <v-col cols="12" class="mt-0 pt-0">
                          Dias
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="3" lg="1" md="1">
                      <v-row>
                        <v-col cols="12" class="text-h3 font-weight-bold mb-0 pb-0">
                          {{ props.hours }}
                        </v-col>
                        <v-col cols="12" class="mt-0 pt-0">
                          Horas
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="3" lg="1" md="1">
                      <v-row>
                        <v-col cols="12" class="text-h3 font-weight-bold mb-0 pb-0">
                          {{ props.minutes }}
                        </v-col>

                        <v-col cols="12" class="mt-0 pt-0">
                          Minutos
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="3" lg="1" md="1">
                      <v-row>
                        <v-col cols="12" class="text-h3 font-weight-bold mb-0 pb-0">
                          {{ props.seconds }}
                        </v-col>

                        <v-col cols="12" class="mt-0 pt-0">
                          Segundos
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </countdown>
            </v-col>
          </v-row>
        </section>
      </v-parallax>
      <section>
      <v-row>
        <v-col cols="12" lg="6" md="6">
          <v-row justify="center" align="center" class="mt-lg-6 ml-lg-4 mt-md-6 ml-md-4 mt-0 ml-0">
            <v-col cols="12" class="text-center">
              <h1 class="font-weight-bold" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">Dónde</h1>
            </v-col>
            <v-col cols="12" class="text-center">
              <h1 class="font-weight-bold " style="font-family: 'Playfair Display'!important; font-style: italic; color: darkslategrey;">Casa Mancorita</h1>
            </v-col>
            <v-col cols="12" class="text-center">
              <center><gmaps-map  :options="options"
                         style='width:100%;  height: 400px;'>
                <gmaps-marker :position="options.position"   />
              </gmaps-map></center>
            </v-col>
          </v-row>

        </v-col>
        <v-col cols="12" lg="6" md="6">
          <v-row justify="center" align="center" class="mt-6 ml-4">
            <v-col cols="12" class="text-center">
              <h1 class="font-weight-bold" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">Cuando</h1>
            </v-col>
            <v-col cols="12" class="text-center" >
              <center><h2 class="text-h4" style="font-family: 'Playfair Display'!important; font-style: italic; color: darkslategrey;" >08 de Diciembre 2023</h2></center>
              <center><h2 class="text-h6" style="font-family: 'Playfair Display'!important; font-style: italic; color: darkslategrey;" >15:30 </h2></center>



            </v-col>
            <v-col cols="12" class="text-center">
              <p><v-icon x-large color="black">fas fa-calendar</v-icon></p>
            </v-col>
            <v-col cols="12" style="font-family: 'Playfair Display'!important; font-style: italic; color: darkslategrey;" class="text-center">
              Guarda al calendario de tu preferencia
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col cols="2">
              <v-btn href="https://www.google.com/calendar/render?action=TEMPLATE&text=Matrimonio%20Karen%20y%20Daniel&dates=20231208T1530-0500/20231209T0000-0500&ctz=America/Lima&details=&location=Mancora&url=http://tunay.app/karenydaniel" target="_blank"><v-icon>fab fa-google</v-icon></v-btn>
            </v-col>
            <v-col cols="2">
              <v-btn href="https://calex.link/e/event/khbCG6dWFIup7yss566W" target="_blank"><v-icon>fab fa-apple</v-icon></v-btn>
            </v-col>
            <v-col cols="2">
              <v-btn href="https://outlook.live.com/owa/?rru=addevent&startdt=2023-12-08T15:30:00&enddt=2023-12-09T00:00:00&subject=Matrimonio%20Karen%20y%20Daniel&ctz=America/Lima&location=Mancora&body=&allday=false&uid=&path=/calendar/view/Month" target="_blank"><v-icon>fab fa-windows</v-icon></v-btn>
            </v-col>
            <v-col cols="2">
              <v-btn href="https://outlook.office365.com/owa/?rru=addevent&startdt=2023-12-08T15:30:00&enddt=2023-12-09T00:00:00&subject=Matrimonio%20Karen%20y%20Daniel&ctz=America/Lima&location=Mancora&body=&allday=false&uid=&path=/calendar/view/Month" target="_blank"><v-icon>fab fa-microsoft</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      </section>
      <section style="background-color: #F9F9F9;" class="mt-12">
<v-row justify="center" align="center" class="mt-12" style="background-color: #F9F9F9;" >
  <center><v-col cols="12">
<v-img src="https://tunayeventos.s3.us-east-2.amazonaws.com/kd/fotoportada2.jpg" width="100" class="rounded-circle mt-12" />
  </v-col></center>
</v-row>
        <v-row class="justify-center" style="background-color: #F9F9F9;" >

    <v-col cols="12">
      <h2 class="text-h4 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">Nuestra historia
      </h2>
    </v-col>

</v-row>
        <v-row class="justify-center pb-12" style="background-color: #F9F9F9;" >
          <v-col lg="6" md="6" sm="10" cols="10" class="mt-12">
            <p class=" text-center pb-12"  style="font-family: 'Playfair Display'!important;  color: #676767;">Todo comenzó con unos cubos de hielo, una cena, un autobús, Madrid, la UEM, Burgos y terminó en un si quiero.
            </p>
            <p class=" text-center pb-12"  style="font-family: 'Playfair Display'!important;  color: #676767;">Contar nuestra historia siempre es muy divertido, no tuvimos un flechazo a primera vista, pero si un poco a poco y un paso a paso. Hemos creado algo especial lleno de amor, felicidad, peleas y muchísima comprensión.
              Y ahora nos queda la vida por delante y solo sabemos que queremos que esa vida sea siempre juntos.</p>
            <p class=" text-center pb-12"  style="font-family: 'Playfair Display'!important;  color: #676767;">Gracias a cada uno de ustedes porque se que vieron y fueron participes de nuestra historia.</p>
          </v-col>
        </v-row>
      </section>
      <section style="background-color: #EFE9E3; color:#444;" >
      <v-row class="pt-12" style="background-color: #EFE9E3; color:#444;" >
<v-col lg="6" cols="12" class="pl-12 pl-lg-8 pt-md-8">
  <v-img width="85%" src="https://tunayeventos.s3.us-east-2.amazonaws.com/kd/ceremonia2.jpeg" />

</v-col>
        <v-col lg="6" cols="12" class="pl-12 pl-lg-0 pl-md-0 pr-12 pr-lg-0 pr-md-0">
          <v-row style="background-color: #EFE9E3; color:#444;">
            <v-col cols="12">
              <v-icon color="#444">fas fa-clock</v-icon> 15:30
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h2 style="font-family: 'Playfair Display'!important; font-style: italic; ">La Ceremonia</h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="8">
              Junto a ustedes y a una puesta de sol norteña nos queremos dar el Sí para toda la vida que dará inicio o el continuará a nuestra vida juntos.
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="8">
              Un atardecer norteño mágico que los y os enamorará porque Piura es la ciudad del eterno calor ese calor que no solo se siente en la temperatura sino en su gente.
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="8" class="mt-12 pt-12">
              <v-img src="https://tunayeventos.s3.us-east-2.amazonaws.com/kd/ceremonia3.jpeg"></v-img>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

        <v-row class="pt-12" style="background-color: #EFE9E3; color:#444;" >

          <v-col lg="6" cols="12" class="pl-12 pl-lg-12 pl-md-12 pr-12 pr-lg-0 pr-md-0">
            <v-row style="background-color: #EFE9E3; color:#444;">
              <v-col cols="12">
                <v-icon color="#444">fas fa-clock</v-icon> 18:00
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <h2 style="font-family: 'Playfair Display'!important; font-style: italic; ">La Celebración</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="8">
                Tendrá lugar en los jardines de casa Mancorita, donde disfrutarémos de una exquisita cena con productos autóctonos de la región.
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="8">
                A continuación, bailaremos hasta el amanecer bajo la luz de las estrellas mientras disfrutaremos de los innovadores cocktails de nuestro barman.
          </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-img width="80%" src="https://tunayeventos.s3.us-east-2.amazonaws.com/kd/celebracion2.jpeg" />
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="6" cols="12" class="pl-12 pl-lg-8 pt-md-8">
            <v-img width="85%" src="https://tunayeventos.s3.us-east-2.amazonaws.com/kd/celebracion4.jpeg" />
          </v-col>
        </v-row>
      </section>
      <section>
        <v-row>
          <v-col cols="12" class="mt-12 pt-12">
            <h2 class="text-h4 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">EL REGALO ES OPCIONAL, <br/>LA ASISTENCIA ES OBLIGATORIA
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center" style="color: black;" >
            pero..... si quieres tener un detalle con nosotros, que mejor regalo que colaborar con nuestra luna de Miel a JAPÓN Y MALDIVAS
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center" style="color: black;" >
            Beneficiario: Karen Tovar & Daniel Martinez <br />
            España: ES62-3035-0238-66-2381074597<br />
            Perú BBVA: CCI-01116000020032964495
          </v-col>
        </v-row>
      </section>
      <section style="background-color: #EFE9E3; color:#444;" class="mt-12">
        <v-row style="background-color: #EFE9E3; color:#444;" class="mt-12">
          <v-col cols="12" class="mt-12 pt-12">
            <h2 class="text-h4 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">Confirmanos tu asistencia
            </h2>
          </v-col>
        </v-row>
        <v-row justify="center" class="pb-12" align="center" style="background-color: #EFE9E3; color:#444;">
          <v-col cols="12" lg="5" md="6">
            <v-row justify="center" align="center">
          <v-col class="text-center" cols="6"  style="color: black;" >
            <v-text-field v-model="vNombre"  label="Nombre" color="black" style="color: black;"> </v-text-field>
          </v-col>
          <v-col class="text-center" cols="6"  style="color: black;" >
            <v-text-field v-model="vApellido" label="Apellidos" color="black" style="color: black;"> </v-text-field>

          </v-col>
              <v-col class="text-center" cols="12"  style="color: black;" >
                <v-text-field v-model="vCorreo" label="Correo Eletrónico" type="email" color="black" style="color: black;"> </v-text-field>

              </v-col>
              <v-col class="text-center" cols="12"  style="color: black;" >
                <v-radio-group row v-model="vAcepta" :mandatory="true">
              <template v-for="estado in estadoeventos">
                <v-radio  class="ma-4"  :value="estado.id"  :key="estado.id" :label="estado.estadoEvento"   active-class="active">
                </v-radio>
              </template>
                </v-radio-group>
              </v-col>
              <v-col>
                <v-btn color="primary" @click="save">Enviar</v-btn>
              </v-col>
            </v-row>

          </v-col>
        </v-row>
          <v-dialog
                  :value="alertnuevo"
                  persistent
                  max-width="380"
          >
              <v-card>
                  <v-card-title class="text-h5">
                      Ingresaron tus Datos!
                  </v-card-title>
                  <v-card-text class="text-h6">Gracias por Responder</v-card-text>
                  <v-card-actions>
                      <v-btn
                              color="green darken-1"
                              text
                              @click="alertnuevo = false"
                      >
                          OK
                      </v-btn>
                  </v-card-actions>
              </v-card>

          </v-dialog>
      </section>
      <section>
        <v-row style="background-color: #F9F9F9;" class="pt-12">

              <v-col cols="12" class=" pt-12">
                <h2 class="text-h4 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">LA MÚSICA
                </h2>
              </v-col>
        </v-row>
        <v-row style="background-color: #F9F9F9;" justify="center" class="pt-12">

          <v-col cols="12" lg="6"  >
            <h2 class="text-h6 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">Hemos creado una playlist en Spotify , queremos que nuestra boda sea la mejor fiesta posible para todos. Por eso os invitamos a que propongáis canciones que os gustaría escuchar.
            </h2>
          </v-col>
        </v-row>
        <v-row style="background-color: #F9F9F9;" justify="center" class="pt-12 pb-12">
          <v-col cols="12" lg="6"  class="text-center" >
            <v-btn href="https://open.spotify.com/playlist/5noq4WzgHArYReTVpuDHl4?si=70f0157f1cdb4bad" target="_blank"><v-icon>fab fa-spotify</v-icon> Lista Karen y Daniel</v-btn>
          </v-col>
        </v-row>
      </section>
      <section>
        <v-row style="background-color: #EFE9E3;" class="pt-12">

          <v-col cols="12" class=" pt-12">
            <h2 class="text-h4 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">INFORMACIÓN ÚTIL
            </h2>
          </v-col>
        </v-row>
        <v-row justify="center" align="center" style="background-color: #EFE9E3;" class="pa-2 pa-lg-12 pa-md-12">
          <v-col cols="12">
            <h2 class="text-h5 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">Tours
            </h2>
            <h2 class="text-h6 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">Agencia de Turismo : Guru Explorers, tiene preparado una oferta especial para nosotros <a href="https://tunaydocs.s3.amazonaws.com/Karen+Tovar+-+Guru+Explorers+-+Paquete+4d3n.pdf" target="_blank">Aqui</a> o también pueden ver sus tours en los links abajo.
            </h2>
          </v-col>
          <v-col cols="12" lg="3" md="6">
            <v-card color="#F9F9F9">
              <v-card-title style="color: black; font-family: 'Playfair Display'!important; ">Cuzco</v-card-title>
              <v-card-text>
             <a href="https://guruexplorers.com/es/destinos/tours-desde-cusco/" target="_blank">  <v-img height="300" src="https://guruexplorers.com/wp-content/uploads/2022/03/Cusco.jpg"></v-img>
               </a>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="3" md="6">
            <v-card color="#F9F9F9">
              <v-card-title style="color: black; font-family: 'Playfair Display'!important; ">Machu Picchu</v-card-title>
              <v-card-text>
                <a href="https://guruexplorers.com/en/destinations/tours-from-cusco/" target="_blank">  <v-img height="300"  src="https://guruexplorers.com/wp-content/uploads/2021/05/Machupicchu001-2.jpg"></v-img>
                </a></v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="3" md="6">
            <v-card color="#F9F9F9">
              <v-card-title style="color: black; font-family: 'Playfair Display'!important; ">Amazonas</v-card-title>
              <v-card-text>
                <a href="https://guruexplorers.com/es/destinos/peru-amazonas-tour/" target="_blank">  <v-img height="300" src="https://guruexplorers.com/wp-content/uploads/2021/06/Amazonas_shutterstock_1346517791.jpg"></v-img>
                </a></v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="3" md="6">
            <v-card color="#F9F9F9">
              <v-card-title style="color: black; font-family: 'Playfair Display'!important; ">Lima e Ica</v-card-title>
              <v-card-text>
                <a href="https://guruexplorers.com/es/destinos/tours-en-lima-e-ica/" target="_blank">  <v-img height="300"  src="https://guruexplorers.com/wp-content/uploads/2022/02/Huacachina-Destinos.jpg"></v-img>
                </a></v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <h2 class="text-h5 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">Recomendaciones Lima
            </h2>
          </v-col>
        </v-row>
        <v-row style="background-color: #EFE9E3;" justify="center" align="stretch">
          <v-col cols="12" lg="4" md="6" class="d-flex flex-column">
            <v-card color="#F9F9F9" class="elevation-5 flex d-flex flex-column">
              <v-card-title style="font-family: 'Playfair Display'!important;  color: black;">Hoteles</v-card-title>
              <v-card-subtitle style="font-family: 'Playfair Display'!important;  color: black;">Barrios Recomendados: Miraflores, San Isidro, Barranco</v-card-subtitle>
              <v-card-text style="font-family: 'Playfair Display'!important;  text-align:justify;color: black;"  class="flex">
                <ul>
                  <li><a href="https://www.booking.com/hotel/pe/jw-marriott-lima.es.html" style="color: black; text-decoration: none;" target="_blank">JW Marriott Hotel Lima</a><v-icon v-for="n in 5" :key="n" style="color:green" x-small>fas fa-star</v-icon></li>
                  <li><a href="https://www.booking.com/hotel/pe/arts-boutique-b.es.html" style="color: black; text-decoration: none;" target="_blank">Hotel B<v-icon v-for="n in 5" :key="n" style="color:green" x-small>fas fa-star</v-icon></a></li>
                  <li><a href="https://www.booking.com/hotel/pe/iberostar-selection-miraflores.es.html" style="color: black; text-decoration: none;" target="_blank">Iberostar Selection Miraflores<v-icon v-for="n in 5" :key="n" style="color:green" x-small>fas fa-star</v-icon></a></li>
                  <li><a href="https://www.booking.com/hotel/pe/the-westin-lima.es.html" style="color: black; text-decoration: none;" target="_blank">The Westin Lima Hotel & Convention Center<v-icon v-for="n in 5" :key="n" style="color:green" x-small>fas fa-star</v-icon>
                  </a></li><li><a href="https://www.booking.com/hotel/pe/pullman-lima-miraflores.es.html" style="color: black; text-decoration: none;" target="_blank">Pullman Lima Miraflores<v-icon v-for="n in 5" :key="n" style="color:green" x-small>fas fa-star</v-icon></a></li>
                  <li><a href="https://www.booking.com/hotel/pe/miraflores-park.es.html" style="color: black; text-decoration: none;" target="_blank">Miraflores Park, A Belmond Hotel
                    <v-icon v-for="n in 5" :key="n" style="color:green" x-small>fas fa-star</v-icon></a></li>
                  <li><a href="https://www.booking.com/hotel/pe/radisson-red-miraflores.es.html" style="color: black; text-decoration: none;" target="_blank">Radisson Red Miraflores<v-icon v-for="n in 4" :key="n" style="color:green" x-small>fas fa-star</v-icon></a></li>
                  <li><a href="https://www.booking.com/hotel/pe/aloft-lima-miraflores.es.html" style="color: black; text-decoration: none;" target="_blank">Aloft Lima Miraflores
                    <v-icon v-for="n in 4" :key="n" style="color:green" x-small>fas fa-star</v-icon></a></li>
                  <li><a href="https://www.booking.com/hotel/pe/innside-by-melia-lima-miraflores.es.html" style="color: black; text-decoration: none;" target="_blank">INNSiDE by Meliá Lima Miraflores
                    <v-icon v-for="n in 4" :key="n" style="color:green" x-small>fas fa-star</v-icon></a></li>
                  <li><a href="https://www.booking.com/hotel/pe/holiday-inn-lima-miraflores.es.html" style="color: black; text-decoration: none;" target="_blank">Holiday Inn<v-icon v-for="n in 4" :key="n" style="color:green" x-small>fas fa-star</v-icon></a></li>
                  <li><a href="https://www.booking.com/hotel/pe/casa-andina-classic-miraflores-san-antonio.es.html" style="color: black; text-decoration: none;" target="_blank">Casa Andina Standard Miraflores San Antonio
                    <v-icon v-for="n in 3" :key="n" style="color:green" x-small>fas fa-star</v-icon></a></li>
                  <li><a href="https://www.booking.com/hotel/pe/lassuites.es.html" style="color: black; text-decoration: none;" target="_blank">Hotel Andesmar
                    <v-icon v-for="n in 3" :key="n" style="color:green" x-small>fas fa-star</v-icon></a></li>
                  <li><a href="https://www.booking.com/hotel/pe/tierra-viva-miraflores-centro.es.html" style="color: black; text-decoration: none;" target="_blank">Tierra Viva
                    <v-icon v-for="n in 3" :key="n" style="color:green" x-small>fas fa-star</v-icon></a></li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="4" md="6" class="d-flex flex-column">
            <v-card color="#F9F9F9" class="elevation-5 flex d-flex flex-column">
              <v-card-title style="font-family: 'Playfair Display'!important;  color: black;">Restaurantes</v-card-title>
              <v-card-subtitle style="font-family: 'Playfair Display'!important;  color: black;"> Desde Ceviches , Carnes y Comida Criolla!</v-card-subtitle>
              <v-card-text style="font-family: 'Playfair Display'!important; text-align:justify;color: black;" class="flex">
<v-row>
  <v-col cols="12" lg="4" md="6" sm="6" >
    <v-icon v-for="n in 3" :key="n" style="color:green" small>fas fa-utensils</v-icon>

    <ul>

      <li>Kjholle</li>
      <li>Central</li>
      <li>Maido</li>
      <li>Rafael</li>
      <li>Astrid y Gaston</li>
      <li>Osaka</li>
      <li>Mayta</li>
      <li>Sapiens</li>
      <li>Osso</li>
      <li>Shinoa</li>
      <li>Fiesta Chiclayo</li>
<li>El Mercado</li>
      <li>Huaca Pucllana</li>
    </ul>

  </v-col>
  <v-col cols="12" lg="4" md="6"  sm="6"  >
    <v-icon v-for="n in 2" :key="n" style="color:green" small>fas fa-utensils</v-icon>
    <ul>
      <li>Isolina</li>
      <li>Panchita</li>
      <li>Mérito</li>
      <li>Edo</li>
      <li>Contraste</li>
      <li>Cosme</li>
      <li>Tanta</li>
      <li>Titi</li>
      <li>Cala</li>
      <li>La Picanteria</li>
    <li>Amor Amar</li>
    </ul>
  </v-col>
  <v-col cols="12" lg="4" md="6"  sm="6"  >
  <v-icon v-for="n in 1" :key="n" style="color:green" small>fas fa-utensils</v-icon>

  <ul>
    <li>Cumpa</li>
    <li>Bodegon</li>
    <li>Primos</li>
    <li>Walok</li>
    <li>Canta Rana</li>
    <li>Mercado San Ramon</li>
    <li>Mercado 28</li>
    <li>La Lucha</li>
    <li>Sandwiches Monstruos</li>
    <li>7 Sopas</li>
  </ul>
          </v-col>
</v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="4" md="6" class="d-flex flex-column">
            <v-card color="#F9F9F9" class="elevation-5 flex d-flex flex-column">
              <v-card-title style="font-family: 'Playfair Display'!important;  color: black;">Bares</v-card-title>
              <v-card-subtitle style="font-family: 'Playfair Display'!important;  color: black;">Un buen Pisco Sour o un Chilcano para refrescar!</v-card-subtitle>

              <v-card-text style="font-family: 'Playfair Display'!important;height: 350px; text-align:justify;color: black;" class="flex">
           <v-row>    <v-col cols="4">
             <v-icon v-for="n in 3" :key="n" style="color:green" small>fas fa-glass-whiskey</v-icon>

             <ul>
                   <li>Perroquet</li>
                   <li>Carnaval</li>
                   <li>Hotel B</li>
                   <li>Bottega Dasso
                   </li>
                   <li>27 tapas</li>
                   <li>Cala</li> <li>Celeste Solar Bar
                 </li>
               <li>Country Club</li>
               <li>Alphonse</li>
               <li>La Sastreria</li>
                 </ul>
               </v-col>
                <v-col cols="4">
                  <v-icon v-for="n in 2" :key="n" style="color:green" small>fas fa-glass-whiskey</v-icon>
                  <ul>

                    <li>Lady Bee
                    </li>
                    <li>Ayahuasca</li>
                    <li>Victoria</li>
                    <li>Bazar</li>
                    <li>Open</li>
                    <li>Limabar</li>
                    <li>Atrio</li>
                    <li>Mandala</li>
                    <li>Medusa</li>
                    <li>Ginebra</li>
                    <li>El Infusionista</li>
                    <li>Maria Mezcal</li>
                  </ul>
                </v-col>
                <v-col cols="4">
                  <v-icon style="color:green" small>fas fa-glass-whiskey</v-icon>
                  <ul>
                    <li>Juanito</li>
                    <li>Cordano</li>
                    <li>Cerveceria del Valle</li>
                    <li>Barranco Beer Company</li>
                    <li>Cachina</li>
                    <li>Barbarian</li>
                    <li>Dorcher Bier</li><li>Mi Tercer Lugar</li>
                    <li>Caños del Santero</li>
                  </ul>
                </v-col>
           </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-col cols="11">
            <v-carousel interval="2000" >
              <v-carousel-item>
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/pU51npuxhck" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </v-carousel-item>
              <v-carousel-item>
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/xFS2nHxZ6L4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </v-carousel-item>
              <v-carousel-item>
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/YW6xgCBPoCo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </v-carousel-item>
              <v-carousel-item>
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/mOiuvlF80EY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </v-carousel-item>
              <v-carousel-item>
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/65DqHLJx9ug" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </v-carousel-item>

            </v-carousel>
          </v-col>
        </v-row>
        <v-row  style="background-color: #EFE9E3;" justify="center" >
          <v-col cols="12">
            <h2 class="text-h5 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">Mancora
            </h2>

          </v-col>
          <v-col cols="12" lg="3" md="4">
            <v-card color="#F9F9F9">
              <v-card-text>
                <iframe height="400" width="100%" src="https://www.youtube.com/embed/GBcKRpmagkk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="3" md="4">
            <v-card color="#F9F9F9">
              <v-card-text>
                <iframe height="400" width="100%" src="https://www.youtube.com/embed/1hOqh3wZ6tQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="3" md="4">
            <v-card color="#F9F9F9">
              <v-card-text>
                <iframe  height="400" width="100%" src="https://www.youtube.com/embed/_cUpDSMk274" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>         </v-card-text>    </v-card>
          </v-col>

          <v-col cols="12">
            <h2 class="text-h5 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">Moneda
            </h2></v-col>
          <v-col cols="8" class="text-center" style="font-family: 'Playfair Display'!important;  color: black;">
            <p>En Perú la moneda que se utiliza es el Nuevo sol es importante recordar cambiar el dinero en casas de cambio oficiales del país, también se puede cambiar en el aeropuerto de Lima. </p>
            <p>Recomiendo el uso de la tarjeta Revolut les indico el siguiente link donde podrán adquirirla <a href="https://revolut.com/referral/karendxm7v" target="_blank">https://revolut.com/referral/karendxm7v</a>
            </p>
            <p>Con esta tarjeta el tipo de cambio es bastante favorable, además la tarjeta gratuita te permite sacar hasta 200€ de cajero y consumos de 1000€ después de esta cantidad te cobran una pequeña comisión, pero tiene distintas opciones que amplían estos montos. </p>
          </v-col>

          <v-col cols="12">
            <h2 class="text-h5 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">Clima
            </h2>
          </v-col>
        </v-row>
<v-row style="background-color: #EFE9E3;" justify="center" align="stretch">
  <v-col cols="12" lg="3" md="4" class="d-flex flex-column">
            <v-card color="#F9F9F9" class="elevation-5 flex d-flex flex-column">
              <v-card-title style="font-family: 'Playfair Display'!important;  color: black;">Lima</v-card-title>
              <v-card-text style="font-family: 'Playfair Display'!important;  text-align:justify;color: black;" class="flex">
                En diciembre Lima la capital tiene un clima bastante cálido por las noches en la zona Miraflores y Larcomar que es donde recomiendo elijan los hoteles suele refrescar, pero con una chaquetilla es más que suficiente.
              </v-card-text>
            </v-card></v-col>
          <v-col cols="12" lg="3" md="4" class="d-flex flex-column">
            <v-card color="#F9F9F9" class="elevation-5 flex d-flex flex-column">
              <v-card-title style="font-family: 'Playfair Display'!important;  color: black;">Cuzco</v-card-title>
              <v-card-text style="font-family: 'Playfair Display'!important; text-align:justify;color: black;" class="flex">
                <p>Recomendamos llevar una chaqueta estilo north face de trekking, es decir un plúmas ligero, pantalones Jeans porque a pesar de ser verano, cusco esta ubicado en la sierra de Perú que tiene un clima totalmente distinto y en las noches suele refrescar un poco como los veranos de Burgos. </p>
                <p>Llevar crema solar, gafas de sol, zapatillas para andar cómodo y gorro.</p>
              </v-card-text>
            </v-card></v-col>
          <v-col cols="12" lg="3" md="4" class="d-flex flex-column">
            <v-card color="#F9F9F9" class="elevation-5 flex d-flex flex-column">
              <v-card-title style="font-family: 'Playfair Display'!important;  color: black;">Máncora</v-card-title>
              <v-card-text style="font-family: 'Playfair Display'!important;   text-align:justify;color: black;" class="flex">
                En diciembre suele tener temperaturas de unos 30 grados, por la brisa marina en las noches puede ser útil un cortavientos o una chaqueta de jean.  Recomendamos traer repelente.

              </v-card-text>
            </v-card></v-col>
</v-row><v-row style="background-color: #EFE9E3;" justify="center" align="center">
          <v-col cols="12">
            <h2 class="text-h5 text-center" style="font-family: 'Playfair Display'!important; font-style: italic; color: black;">Unos puntos más de Perú
            </h2>
          </v-col>
          <v-col cols="12" lg="6" md="6" class="text-center">
            <center><v-img src="https://tunayeventos.s3.us-east-2.amazonaws.com/kd/imgperu.jpg" class="rounded-circle" width="60%" contain></v-img></center>
          </v-col>
          <v-col cols="12" lg="5" md="5" style="color: black; text-align: justify;">
            <ul>
              <li>
                El agua en Perú no es potable por lo que siempre recuerden comprar agua embotellada. Por favor no tomar agua del grifo.
              </li>
              <li>
                Al momento de ir al baño siempre van a encontrar basureros pequeños esto se debe a que en Perú no se puede tirar el papel higiénico en los inodoros. Siempre usar el basurero ya que pueden causar daños al local u hotel.
              </li>
              <li>
                Si desean movilizarse en taxi siempre usar la aplicación de uber o cabify no tomar taxis de la calle, suelen aprovecharse de los extranjeros y pueden llegar a robarte ya que no son taxis regulados.
              </li>
              <li>
                Si quieren comprar recuerdos en el mercado del INKA o en Cuzco recuerden que siempre se puede negociar porque hay veces que los vendedores al ver extranjeros suelen subir un poco los precios.
              </li>
              <li>
                En los tours por favor siempre hacer caso, en especial en Cuzco, es una ciudad con mucha altura lo que puede ocasionar mareos y malestar y necesidad de oxigeno ya que a este le cuesta más llegar a nuestro cerebro en Perú se le conoce como soroche. Lo que recomiendo desde mi experiencia personal es que el primer día que lleguen no intenten querer ya conocer todo y hacer actividades como en sus rutinas normales, descansen coman suave una sopa, mucho mate de coca y tomarse un <a href="https://www.sorojchipills.com/es" target="_blank">sorojchi pills</a> lo podrán encontrar en la Farmacia del aeropuerto de Lima y en cualquier farmacia.
              </li>
            </ul>
          </v-col>
        </v-row>
      </section>
    </v-container>

  <v-overlay :value="overlay">
    <v-img
        src="@/assets/loadtunay.gif"

    />
  </v-overlay>


  </v-app>
</template>

<script>


import {gmapsMap, gmapsMarker} from "x5-gmaps";
import axios from "axios";


export default {
    name: 'karenydaniel',
    title: 'Matrimonio Karen y Daniel',
    components: {
      gmapsMap,
      gmapsMarker
  },
    data () {
      return {
        fiestas: [],
        eventos: [],
        negocios:[],
        email: '',
        eventData: {},
        vNombre:'',
        vApellido:'',
          alertnuevo:false,
        estadoeventos:[{
          id:20,
          estadoEvento:'Asistirá',
          color:'green',
          categoriaId:5,
          activo:true,
          publico:true
        },{
          id:21,
          estadoEvento:'No Asistirá',
          color:'red',
          categoriaId:5,
          activo:true,
          publico:true
        }
        ],
        vCorreo:'',
        vAcepta:'',
        tab: null,
        tag:'karenydaniel',
        codigoUnico:'',
        rese:'',
        overlay:false,
        tiempo:0,
        options:{
          position:{ lat: -4.1124785, lng: -81.0762557 },
          center:{ lat: -4.1124785, lng: -81.0762557 },
          zoom: 18
        },
        stylePagina: {
          backgroundColor: 'white',
          color:'white',
          backgroundImage:'https://tunayeventos.s3.us-east-2.amazonaws.com/kd/backgroundkd.jpg',
          backgroundRepeat: 'repeat',
          height:"100%",

        },
        emailRules: [
          v => !!v || 'Se necesita el Email',
          v => /.+@.+/.test(v) || 'E-mail debe ser valido',
        ]
          }
    },
    mounted(){
      let currentDateObj = new Date();
      let fechaobjetiva = new Date('2023-12-08 15:30:00')
      let numberOfMlSeconds = currentDateObj.getTime();
      let tiempobjetivo = fechaobjetiva.getTime();
      this.tiempo = tiempobjetivo-numberOfMlSeconds;

    },
    methods: {

      save(){
        this.overlay=true
        var bodyFormData = new FormData();
        bodyFormData.append("nombre",this.vNombre)
        bodyFormData.append("apellido",this.vApellido)
        bodyFormData.append("email",this.vCorreo)
        bodyFormData.append("estadoEventoId",this.vAcepta)
        bodyFormData.append("tagevento",this.tag)
        this.rest = true
        axios
            .post('tickets/grabar/matrimonio',bodyFormData)
            .then(response => {
              let ticketMin = response.data;
              console.log(ticketMin)
              this.alertnuevo = true
              this.rest = false
              this.overlay = false
            })
            .catch((error)  => {
              console.log(error);
              this.overlay = false
            });


      }
    }
  }
</script>
<style>

.v-parallax__image-container {
  -webkit-filter: grayscale(200%);
  filter: grayscale(200%);

}

.theme--dark.v-label {
  color: black;
}
.theme--dark.v-input, .theme--dark.v-input input, .theme--dark.v-input textarea{
  color:black;
}
</style>
